import emailjs from '@emailjs/browser';

export const sendEmail = (service_id, template_id, data, user_id, cb) => {
  emailjs.send(service_id, template_id, data, user_id).then(
    (res) => cb?.(res, true),
    (err) => cb?.(err, false)
  );
};
